import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { connect } from "react-redux";
import JwtDecode from "jwt-decode";
import Axios from "axios";
import Pagination from "@material-ui/lab/Pagination";

import { url } from "../../../../config/config";
import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import Oops from "../../../../Assets/Images/Oops.png";
import AuthorBooks from "./AuthorBooks";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./AuthorMyBooks.css";

class AuthorMyBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      isEmpty: false,
      expanded: "",
      currentPage: 1,
      postPerPage: 5,
    };
  }

  componentDidMount() {
    if (this.props.authorToken) {
      this.getBooks(this.props.authorToken);
    }
  }

  getBooks = async (token) => {
    let decodeData = JwtDecode(token);
    const response = await Axios.get(`${url}/api/books/allBooks`, {
      params: {
        author: decodeData._id,
      },
      headers: {
        "x-auth-token": token,
      },
    });
    if (response.data.length !== 0) {
      this.setState({
        books: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        books: [],
        isEmpty: true,
      });
    }
  };

  handlePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  render() {
    const { classes } = this.props;
    const { books, currentPage, postPerPage } = this.state;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          {this.state.books.length !== 0 ? (
            <div>
              <div style={{ fontSize: 24 }}>My Book List</div>
              <Divider />
              <br />
              <AuthorBooks
                books={books}
                currentPage={currentPage}
                postPerPage={postPerPage}
              />
              <div className={classes.paginationStyle}>
                <Pagination
                  count={Math.ceil(books.length / postPerPage)}
                  color="secondary"
                  page={currentPage}
                  boundaryCount={1}
                  onChange={this.handlePage}
                  showFirstButton
                  showLastButton
                />
              </div>
            </div>
          ) : this.state.isEmpty === true ? (
            <CustomEmptyMessage
              button={true}
              message="You haven't publish any book."
              buttonLabel="Publish Your book"
              buttonUrl={() => this.props.history.push("/book/publish/rules")}
              image={Oops}
            />
          ) : (
            <CustomLoader />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authorToken: state.AuthorReducer.authorToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(AuthorMyBooks)));
